import React, { Component } from 'react'
import { string, bool, oneOfType } from 'prop-types'
import { skyBlue, grey } from '../../../styles/settings/colors'

import { Icon } from '../Icon'
import TextInput from '../TextInput'
import StepCounter from '../StepCounter'

import { Content, SecurityLevel, ShowPassword, Wrapper } from './styles'

class PasswordInput extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showPassword: false
    }
  }

  preventDefault = e => {
    e.preventDefault()
  }

  togglePassword = () => {
    this.setState({
      showPassword: !this.state.showPassword
    })
  }

  render() {
    const { showPassword } = this.state

    const { passwordStrength, passwordMessage, errorMessage, loading, maxlength } = this.props

    const isSecurity = !showPassword
    const inputType = isSecurity ? 'password' : 'text'

    return (
      <Wrapper isSecurity={isSecurity}>
        <Content>
          <TextInput
            {...this.props}
            onCopy={this.preventDefault}
            onCut={this.preventDefault}
            onPaste={this.preventDefault}
            type={inputType}
            maxlength={maxlength}
            errorMessage={errorMessage || (!!passwordStrength && passwordStrength < 8)}
          />
          {!loading && (
            <ShowPassword onClick={this.togglePassword}>
              <Icon
                width="24"
                height="24"
                icon="eye"
                viewBox="0 -20 100 100"
                color={showPassword ? skyBlue : grey}
              />
            </ShowPassword>
          )}
        </Content>
        {(passwordMessage || passwordStrength) && (
          <SecurityLevel>
            <StepCounter counter={passwordStrength} message={passwordMessage} />
          </SecurityLevel>
        )}
      </Wrapper>
    )
  }
}

TextInput.defaultProps = {
  passwordStrength: null,
  passwordMessage: null
}

TextInput.propTypes = {
  passwordStrength: oneOfType([string, bool]),
  passwordMessage: oneOfType([string, bool])
}

export default PasswordInput



// WEBPACK FOOTER //
// ./src/app/elements/PasswordInput/PasswordInput.js